import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"

// Filtre client de la table des bilans : recherche texte + statut.
// Chaque <tr> porte data-search (texte normalisé) et data-status.
export default class extends Controller {
  static targets = ["row", "search", "status", "membre", "count"]

  filter() {
    const matcher = makeMatcher(this.hasSearchTarget ? this.searchTarget.value : "")
    const status = this.hasStatusTarget ? this.statusTarget.value : ""
    const membre = this.hasMembreTarget ? this.membreTarget.value : ""
    let visible = 0

    this.rowTargets.forEach((row) => {
      const matchTerm = matcher(row.dataset.search || "")
      const matchStatus = !status || row.dataset.status === status
      const matchMembre = !membre || (row.dataset.membres || "").split(" ").includes(membre)
      const show = matchTerm && matchStatus && matchMembre
      row.hidden = !show
      if (show) visible += 1
    })

    if (this.hasCountTarget) this.countTarget.textContent = visible
    if (this.hasEmptyRow) this.emptyRow.hidden = visible !== 0
  }

  get hasEmptyRow() {
    this._emptyRow ||= this.element.querySelector("[data-empty-row]")
    return !!this._emptyRow
  }

  get emptyRow() {
    return this._emptyRow
  }
}
